import { render, staticRenderFns } from "./PAP.vue?vue&type=template&id=3168b2f9&"
import script from "./PAP.vue?vue&type=script&lang=js&"
export * from "./PAP.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PAP.vue?vue&type=style&index=1&id=3168b2f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports